/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function isVisible(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function closeChattyWelcomePanel() {
    if (window.__vpChattyWelcomeClosed) return true;

    var possiblePanels = Array.prototype.slice.call(
      document.querySelectorAll('[class*="Avada-Faq"], [class*="chatty"], [id*="chatty"]')
    );

    var openPanel = possiblePanels.find(function(element) {
      var text = element.innerText || '';
      return isVisible(element) && text.indexOf('Hi, welcome to Verity Pearl') !== -1;
    });

    if (!openPanel) return false;

    var closeControls = Array.prototype.slice.call(
      openPanel.querySelectorAll('button, [role="button"], [aria-label*="close" i], [class*="close" i]')
    );

    var closeControl = closeControls.find(function(element) {
      if (!isVisible(element)) return false;
      var rect = element.getBoundingClientRect();
      var panelRect = openPanel.getBoundingClientRect();
      return rect.top <= panelRect.top + 90 && rect.left >= panelRect.right - 120;
    });

    if (closeControl) {
      closeControl.click();
      window.__vpChattyWelcomeClosed = true;
      return true;
    }

    return false;
  }

  window.addEventListener('load', function() {
    var attempts = 0;
    var timer = window.setInterval(function() {
      attempts += 1;
      if (closeChattyWelcomePanel() || attempts >= 16) {
        window.clearInterval(timer);
      }
    }, 500);
  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
